export const eventType = {
    CREATE_NEW_DESIGN: "design.createNew",
    RECENT_DESIGN: "design.recent",
    ADD_BATCH_RECIPE: "ingrediants.createBatchRecipe",
    ADD_CUSTOM_INGREDIANT: "ingrediants.addIngrediant",
  };
  
  export const menuItemsData = [
    {
      title: "Designs",
      url: "/designs",
      submenu: [
        {
          title: "Create New",
          url: "/designs",
          submenu: [],
        },
        {
          title: "Open Recent",
          url: "/designs",
          submenu: [],
        },
        {
          title: "See All",
          url: "/designs",
          isBlueLink: true,
        },
      ],
    },
    {
      title: "Menu Engineering",
      url: "/menu-engineering",
    },
    {
      title: "Recipes",
      url: "/recipes",
    },
    {
      title: "Ingredients",
      url: "/ingredients",
      submenu: [
        {
          title: "Batch Recipes",
          url: "/ingredients",
          submenu: [
            {
              title: "Add A Batch Recipe",
              url: "",
              isCallFunc: true,
              eventType: eventType.ADD_BATCH_RECIPE,
            },
          ],
        },
        {
          title: "Custom Ingredients",
          url: "/ingredients?tab=custom-ingredients",
          submenu: [
            {
              title: "Add A Custom Ingredient",
              url: "/ingredients?tab=custom-ingredients&action=add",
              isCallFunc: true,
              eventType: eventType.ADD_CUSTOM_INGREDIANT,
            },
          ],
        },
        {
          title: "View Sysco Products",
          url: "/ingredients?tab=sysco-products",
        },
      ],
    },
  ];
  